import React, { useEffect, useState } from "react"
import Api from "../../../../_helpers/Api"
import Skeleton from "react-loading-skeleton"
import { trans } from "../../../../_providers/Translation"
import "../../../../assets/css/partials/status-diagram.css"
import DateRange from "@/components/partials/DateRange"
import moment from "moment"

export default function ResolvedTickets() {
  const [state, setState] = useState({ loading: true, data: null })
  const [filters, setFilters] = useState({ employee_id: "" })

  const loadData = () => {
    setState((prev) => ({ ...prev, loading: true }))

    Api.get(`analytics/ticket-resolution?employee_id=${filters.employee_id}`)
      .then((res) => {
        setState({
          loading: false,
          data: res.data.data,
          employees: res.data.employees,
        })
      })
      .catch(() => setState({ loading: false, data: null }))
  }

  useEffect(() => {
    loadData()
  }, [filters])

  const itemsSource = [
    {
      key: "normal",
      label: "Нормални",
      value: state.data?.normal.count || 0,
      color: "#6B84DF",
    },
    {
      key: "priority",
      label: "С висок приоритет",
      value: state.data?.priority.count || 0,
      color: "#EC5252",
    },
    {
      key: "unsolved",
      label: "Нерешени",
      value: state.data?.unsolved.count || 0,
      color: "#C6D2FD",
    },
  ]

  const items = itemsSource

  function getTotalResults() {
    return items.reduce((sum, it) => sum + Number(it.value || 0), 0)
  }

  function handleFilterChange(e) {
    const { name, value } = e.target

    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  return (
    <div className="resolved-tickets-chart">
      <div className="head">
        <h3>Решаване на тикети</h3>
        <div className="right">
          {state.loading ? (
            <Skeleton height={40} width={140} count={1} />
          ) : (
            <select
              value={filters.employee_id || ""}
              name="employee_id"
              onChange={handleFilterChange}
            >
              {state.employees?.map((employee) => (
                <option key={employee.id} value={employee.id}>
                  {employee.name}
                </option>
              ))}
            </select>
          )}
        </div>
      </div>
      <hr />
      {state.loading ? (
        <Skeleton height={200} count={1} />
      ) : getTotalResults() === 0 ? (
        <div
          className="alert info"
          style={{
            marginBottom: 0,
          }}
        >
          {trans("messages.noDataFound")}
        </div>
      ) : (
        <div className="body">
          <div className="bubble-chart">
            {(() => {
              const maxSize = 200
              const minSize = 70
              const sorted = [...items].sort(
                (a, b) => Number(b.value) - Number(a.value),
              )
              const maxVal = Math.max(...sorted.map((i) => Number(i.value)), 1)

              const bubbles = sorted.map((it) => {
                const ratio = Number(it.value) / maxVal
                const diameter =
                  minSize + (maxSize - minSize) * Math.sqrt(ratio)
                return { ...it, diameter }
              })

              // Positions: largest left, medium top-right, smallest bottom-right
              const positions = [
                { top: "10%", left: "0" },
                { top: "0", right: "0" },
                { bottom: "0", right: "5%" },
              ]

              return bubbles.map((b, idx) => (
                <div
                  key={b.key}
                  className="bubble"
                  style={{
                    width: b.diameter,
                    height: b.diameter,
                    backgroundColor: b.color,
                    border: "4px solid #fff",
                    ...positions[idx],
                  }}
                >
                  {b.value}
                </div>
              ))
            })()}
          </div>

          <ul>
            {items.map((it, idx) => {
              return (
                <li key={it.key || it.label || idx}>
                  <span style={{ backgroundColor: it.color }} />
                  {it.label}
                </li>
              )
            })}
          </ul>
        </div>
      )}
    </div>
  )
}
